import * as React from 'react';
import { useContext } from 'react';

import { NotificationContext } from '../../context/NotificationContext';
import { NotificationBanner } from '../NotificationBanner/NotificationBanner';

export const NotificationList = ({ className = '' }) => {
    const { notifications } = useContext(NotificationContext);

    return (
        <div className={className}>
            {notifications.map((it) => (
                <NotificationBanner key={it.id} notification={it} />
            ))}
        </div>
    );
};
